import OverlayTips from "./OverlayTips";
import _ from "underscore";
import PageOverlayTipsManager from "./PageOverlayTipsManager";
import $ from "jquery";
import messageResource from "../messageResource";

function OverlayTipsKit()
{
    this._tipConfigs = {};
    this._queue = [];
}

OverlayTipsKit.prototype = {
    /**
     * Hides all tips.
     */
    hideAll: function()
    {
        _.each(_.values(this._tipConfigs), function(config) { config.tip.atAnimation().fadeOut() });
    },

    /**
     * Shows all tips.
     */
    showAll: function()
    {
        _.each(_.values(this._tipConfigs), function(config) { config.tip.atAnimation().fadeIn() });
        this.repositionOutsideTips();
        PageOverlayTipsManager.getInstance().disableFirstTimeCookie();
    },

    /**
     * Removes tip from the DOM.
     * @param id Tip ID.
     */
    remove: function(id)
    {
        this._tipConfigs[id].tip.remove();
        delete this._tipConfigs[id];
    },

    /**
     * Removes all tips from the DOM.
     */
    removeAll: function()
    {
        _.each(_.values(this._tipConfigs), function(config)
        {
            config.tip.remove();
        });
        this._tipConfigs = {};
    },

    /**
     * Adds config for an overlay tip to be positioned.
     * @param config Overlay tip config
     */
    enqueueTip: function(config)
    {
        this._init();

        // Set config defaults
        config = _.defaults(config, {
            show: false,
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 0,
            offsetY: 0
        });

        if (config.outside)
        {
            config.outside = _.defaults(config.outside, {
                direction: config.direction,
                offsetX: config.offsetX,
                offsetY: config.offsetY
            })
        }

        // Create tip element
        config.tip = $("<div>").addClass("overlayTip");

        // Append text lines
        var text = config.text;
        if (config.messageKey) text = messageResource.getMessage(config.messageKey);
        _.each(text.split("\n"), function(line)
        {
            config.tip.append($("<div>").addClass("overlayTipLine").text(line)).append("<br/>");
        });

        // Append arrow
        config.arrow = $("<div>").addClass("overlayTipArrow");
        config.tip.append(config.arrow);

        // Add tip element ID
        config.id = OverlayTips._idSequence++;
        config.tip.attr("id", "overlayTip" + config.id);

        // Add extra classes to the tip
        if (config.extraClass)
            config.tip.addClass(config.extraClass);

        // Config processed only if it remain in _tipConfigs
        this._tipConfigs[config.id] = config;

        if (config.calculatedSizes)
            this._processTip(config);
        else
        {
            // Before we set tip position, it's added as a hidden body child,
            // where browser will calculate its dimensions
            $("body").append(config.tip);

            // Schedule queue processing
            if (this._queue.length == 0) this.scheduleQueueProcessing();
            this._queue.push(config);
        }

        return config;
    },

    scheduleQueueProcessing: function()
    {
        defer(_.bind(this._processQueue, this));
    },

    isQueueProcessed: function()
    {
        return this._queue.length == 0;
    },

    /**
     * Processes tips queue.
     * @private
     */
    _processQueue: function()
    {
        _.each(this._queue, this._processTip, this);
        this._queue = [];
        this.repositionOutsideTips();
    },

    /**
     * Inserts tip element into DOM, setting coordinates.
     * @param config Overlay tip config
     * @private
     */
    _processTip: function(config)
    {
        // Check if config processed after it was removed
        if (!this._tipConfigs[config.id])
            return;

        var relativeTo = config.relativeTo;
        var tip = config.tip;

        this._positionTip(config);

        // Make tip visible
        tip.addClass("visible");

        // Show the tip immediately if needed
        if (config.show)
        {
            // Only animate if this is a fresh tip or if refresh animation is enabled
            if (config.refreshAnimated || (!config.processedOnce && !config.noFirstTimeAnimation))
                tip.atAnimation().fadeIn();
            else
                tip.show();
        }
        else
            tip.hide();

        // Determine a way to put a wrapper element - inside or outside the relative
        var relativeToDisplay = relativeTo.css("display");
        var wrapInner = config.wrapInner || relativeTo.is("td");
        var wrapper;
        if (wrapInner)
        {
            // Try to find existing wrapper inside
            wrapper = relativeTo.children(".overlayTipWrapper");
            if (wrapper.length == 0)
            {
                // Existing wrapper not found, create new
                relativeTo.wrapInner($("<div>").addClass("overlayTipWrapper"));
                wrapper = relativeTo.children(".overlayTipWrapper");
            }
        }
        else
        {
            // Try to find existing wrapper outside
            wrapper = relativeTo.parent(".overlayTipWrapper");
            if (wrapper.length == 0)
            {
                // Existing wrapper not found, create new
                wrapper = $("<div>").addClass("overlayTipWrapper");
                if (relativeToDisplay == "inline-block" || relativeToDisplay == "inline")
                {
                    // Correct position properties for inline relative
                    wrapper.css("display", "inline-block");
                    wrapper.css("vertical-align", relativeTo.css("vertical-align"));
                }
                relativeTo.wrap(wrapper);
                wrapper = relativeTo.parent();
            }
        }

        // Prevent event bubble from tip
        config.tip.on("click mousedown mouseup mouseover", function(e) {stopEventPropagation(e);});

        // Add the tip to the wrapper removing any old tips
        wrapper.children(".overlayTip").remove();
        wrapper.append(tip);

        // Remember actual DOM elements
        config.tip = wrapper.children(".overlayTip");
        config.arrow = config.tip.children(".overlayTipArrow");

        // Mark tip as processed once in the config
        config.processedOnce = true;
    },

    /**
     * Sets tip and arrow element positions.
     * @private
     */
    _positionTip: function(config)
    {
        var tip = config.tip;
        var arrow = config.arrow;

        var positionConfig = config;
        if (config.outsideActive)
            positionConfig = config.outside;
        var direction = positionConfig.direction;
        var offsetX = positionConfig.offsetX;
        var offsetY = positionConfig.offsetY;
        var anchor = positionConfig.anchor;

        // Calc tip and arrow base offsets
        if (!config.calculatedSizes)
        {
            // Sizes are calculated only once and are remembered for future use
            config.calculatedSizes = {
                arrowWidth: arrow.width(),
                tipWidth: tip.width(),
                tipHeight: tip.height()
            };
        }

        var arrowOffsetX = -config.calculatedSizes.arrowWidth - 5;
        var arrowOffsetY = 0;
        var tipOffsetX = -config.calculatedSizes.tipWidth + arrowOffsetX - offsetX;
        var tipOffsetY = -config.calculatedSizes.tipHeight + arrowOffsetY - offsetY;

        // Clear any prior attributes
        tip.css("left", "").css("top", "").css("right", "").css("bottom", "");
        arrow.css("left", "").css("top", "").css("right", "").css("bottom", "");
        arrow.removeClass("topLeft").removeClass("topRight").removeClass("bottomLeft").removeClass("bottomRight");

        if (anchor)
        {
            var flag = direction ^ anchor;
            if ((flag & (OverlayTips._ANCHOR_LEFT | OverlayTips._ANCHOR_RIGHT)) !== 0)
            {
                if (!config.calculatedSizes.relativeWidth) config.calculatedSizes.relativeWidth = config.relativeTo.width();
                tipOffsetX += config.calculatedSizes.relativeWidth;
            }
            if ((flag & (OverlayTips._ANCHOR_TOP | OverlayTips._ANCHOR_BOTTOM)) !== 0)
            {
                if (!config.calculatedSizes.relativeHeight) config.calculatedSizes.relativeHeight = config.relativeTo.height();
                tipOffsetY += config.calculatedSizes.relativeHeight;
            }
        }

        // Set tip and arrow coordinates
        switch (direction)
        {
            case OverlayTips.DIRECTION_TOP_LEFT:
                tip.css("left", tipOffsetX + "px");
                tip.css("top", tipOffsetY + "px");
                arrow.css("right", arrowOffsetX + "px");
                arrow.css("bottom", arrowOffsetY + "px");
                arrow.addClass("topLeft");
                break;
            case OverlayTips.DIRECTION_TOP_RIGHT:
                tip.css("right", tipOffsetX + "px");
                tip.css("top", tipOffsetY + "px");
                arrow.css("left", arrowOffsetX + "px");
                arrow.css("bottom", arrowOffsetY + "px");
                arrow.addClass("topRight");
                break;
            case OverlayTips.DIRECTION_BOTTOM_LEFT:
                tip.css("left", tipOffsetX + "px");
                tip.css("bottom", tipOffsetY + "px");
                arrow.css("right", arrowOffsetX + "px");
                arrow.css("top", arrowOffsetY + "px");
                arrow.addClass("bottomLeft");
                break;
            case OverlayTips.DIRECTION_BOTTOM_RIGHT:
                tip.css("right", tipOffsetX + "px");
                tip.css("bottom", tipOffsetY + "px");
                arrow.css("left", arrowOffsetX + "px");
                arrow.css("top", arrowOffsetY + "px");
                arrow.addClass("bottomRight");
                break;
        }
    },

    /**
     * Re-position tips, which have fallen outside the screen.
     */
    repositionOutsideTips: function()
    {
        var self = this;
        _.each(_.values(this._tipConfigs), function(config)
        {
            // Only process tips with configured alternative position
            if (config.outside)
            {
                var tip = config.tip;
                var left = tip.offset().left;

                if (!tip.hasClass("outside") && left < 0)
                {
                    // Tip was on usual position but is outside now, so move it to alternate position
                    config.outsideActive = true;
                    self._positionTip(config);
                    tip.addClass("outside");

                    // Remember this, so we know when to put the tip back
                    var newLeft = tip.offset().left;
                    config.outside.leftDiff = newLeft - left;
                }
                else if (left - config.outside.leftDiff > 0)
                {
                    // Tip was on alternate position, but its regular position would be inside, so move it back
                    config.outsideActive = false;
                    self._positionTip(config);
                    tip.removeClass("outside");
                }
            }
        });
    },

    _init: function()
    {
        OverlayTips.init();
    }
};

export default OverlayTipsKit;


// WEBPACK FOOTER //
// ./web/js/tips/OverlayTipsKit.js